export { default } from './NavigationMenuGroupItem';
